import { render } from "./Destroy.vue?vue&type=template&id=2d997962&scoped=true"
import script from "./Destroy.vue?vue&type=script&lang=js"
export * from "./Destroy.vue?vue&type=script&lang=js"

import "./Destroy.vue?vue&type=style&index=0&id=2d997962&scoped=true&lang=css"
/* custom blocks */
import block0 from "@/locales/components/views/agro_exporter/production/uniq_final_packing_list/show_container/tabs/pallets/destroy.yml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fnoe%2FDev%2Fatc%2Fagrotecchain_vue%2Fsrc%2Fcomponents%2Fviews%2Fagro_exporter%2Fproduction%2Funiq_final_packing_list%2Fshow_container%2Ftabs%2Fpallets%2FDestroy.vue&lang=yaml"
if (typeof block0 === 'function') block0(script)
import block1 from "@/locales/models/package_group.yml?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fhome%2Fnoe%2FDev%2Fatc%2Fagrotecchain_vue%2Fsrc%2Fcomponents%2Fviews%2Fagro_exporter%2Fproduction%2Funiq_final_packing_list%2Fshow_container%2Ftabs%2Fpallets%2FDestroy.vue&lang=yaml"
if (typeof block1 === 'function') block1(script)


import exportComponent from "/home/noe/Dev/atc/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d997962"]])

export default __exports__